import { useAccount } from "@/hooks/useAccount";
import { useTenants } from "@/hooks/useTenants";
import { describePerimeter, needsAccessConfiguration } from "@/pages/home/homeDashboards";

export function useAccountSetup() {
  const account = useAccount();
  const tenants = useTenants();
  const requiresScopeCheck =
    account.isSuccess &&
    account.data.data_limited_to_scopes === true &&
    account.data.scopes.length === 0;

  return {
    needsSetup:
      account.isSuccess &&
      tenants.isSuccess &&
      needsAccessConfiguration(
        account.data.scopes,
        describePerimeter(
          account.data.scopes,
          tenants.data,
          account.data.data_limited_to_scopes ?? false,
        ),
      ),
    isPending: account.isPending || (requiresScopeCheck && tenants.isPending),
    error: account.error ?? (requiresScopeCheck ? tenants.error : null),
    retry: () => {
      void account.refetch();
      void tenants.refetch();
    },
  };
}
